import React from 'react'

export const QuantifyHome = () => {
  return (
    <div>QuantifyHome</div>
  )
}

